import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./views/Home";
import Processing from "./views/Processing";
import NavBar from "./components/NavBar";
import useEagerConnect from "./hooks/useEagerConnect";
import SnapshotReview from "./views/SnapshotReview";
import { Container } from "./components/styled/Container";
import styled from "styled-components";
import Footer from "./components/Footer";
import TokenSubmission from "./views/TokenSubmission";
import TransactionConfirm from "./views/TransactionConfirm";
import Transactions from "./views/Transactions";
import ProtectedSnapshotRoute from "./components/Utilities/ProtectedRoute";
import useSnapshotHistory from "./hooks/useSnapshotHistory";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "./store";
const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

const App = () => {
  const dispatch = useDispatch<Dispatch>();
  const { snapshotHistory, removeSingleSnapshot } = useSnapshotHistory();
  useEagerConnect();

  useEffect(() => {
    const localStorageSnapshotIds = Object.values(snapshotHistory);
    localStorageSnapshotIds.forEach(async (snapshot) => {
      const isSnapshotFound = await dispatch.snapshotModel.checkSnapshotId(
        snapshot.snapshotId
      );
      if (!isSnapshotFound) {
        removeSingleSnapshot(snapshot.snapshotId);
      }
    }, []);
  }, [snapshotHistory, dispatch, removeSingleSnapshot]);
  return (
    <div className="app">
      <AppWrapper>
        <NavBar />
        <Container>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/token-submit" element={<TokenSubmission />} />
            <Route
              path="/processing"
              element={<ProtectedSnapshotRoute component={Processing} />}
            />
            <Route
              path="/snapshot-review"
              element={<ProtectedSnapshotRoute component={SnapshotReview} />}
            />
            <Route
              path="/tx-confirm"
              element={
                <ProtectedSnapshotRoute component={TransactionConfirm} />
              }
            />
            <Route
              path="/transactions"
              element={<ProtectedSnapshotRoute component={Transactions} />}
            />
          </Routes>
        </Container>
        <Footer />
      </AppWrapper>
    </div>
  );
};

export default App;
